import React from 'react';
import './SessionVideos.css';

const SessionVideos = () => {
  return (
    <section id="session-videos" className="sec">
      <div className="sec-inner">
        <div className="sec-label">10 — Session Videos</div>
        <h2 className="sec-title">Featured<br /><em>Sessions</em></h2>

        <p className="session-videos-intro">
          As an active tech community contributor and speaker, I regularly host and deliver insightful sessions on cutting-edge technologies. Watch my featured tech talks and workshops, covering topics like Convolutional Neural Networks (CNNs), Artificial Intelligence, and modern software engineering practices.
        </p>

        <div className="session-videos-body reveal">
          <div className="sv-card">
            <div className="sv-card-header">
              <span className="dot dot-red"></span>
              <span className="dot dot-yellow"></span>
              <span className="dot dot-green"></span>
              <div className="sv-card-title">Live Session</div>
            </div>
            <div className="video-responsive">
              <iframe
                src="https://www.youtube.com/embed/hxpWl6kG4_c"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                title="CNN Session Video"
              ></iframe>
            </div>
            <div className="sv-card-footer">
              <div className="sv-caption-title">The Eyes of AI — A Beginner's Journey into CNN (Convolutional Neural Networks)</div>
              <div className="sv-caption-subtitle">Exploring deep learning concepts and real-world applications</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SessionVideos;
